module.exports = __webpack_public_path__ + "static/media/preloader.c84bc4ba.svg";